import * as React from 'react';
export const ocbcSvg = React.forwardRef(function ocbcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E11A27',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.36 12.32 6.32 8.96c.8-1.12 1.76-2.08 2.96-2.8l4.32 4.4c-.88.4-1.68.96-2.24 1.76Zm-1.28 3.12L4.4 13.28c.32-1.36.88-2.64 1.6-3.84l5.12 3.2c-.64.8-.96 1.76-1.04 2.8Zm6.8 2.64-6.16-2.4c.16-.96.56-1.84 1.12-2.56l5.04 3.2v1.76Zm0-2.08-4.8-3.2c.56-.72 1.36-1.2 2.16-1.52l2.56 2.56V16h.08ZM4.72 20.08c-.48-1.28-.72-2.56-.72-4 0-.8.08-1.52.24-2.32l5.84 2.08v.24c0 1.36.48 2.72 1.36 3.76h.08c-.48-.96-.8-1.92-.8-3.04 0-.24 0-.48.08-.72l6.24 2.16V20l-12.32.08Zm.4 1.12c-.08-.24-.16-.48-.32-.719h3.6l.64.72h5.36l-1.12 1.2H6.64c-.16-.64-.8-1.2-1.52-1.2Zm14.8-.56c.24-.16.48-.4.64-.64.96-1.12 1.52-2.4 1.52-3.92 0-3.36-2.72-6.08-6.08-6.08-.72 0-1.36.08-1.92.32L9.84 5.68C11.6 4.64 13.76 4 16 4c6.72 0 12 5.36 12 12s-5.36 12-12 12c-3.28 0-6.24-1.36-8.48-3.52h14.72l.08-.08-15.44-.56-.08-.08h16.48l.08-.079-17.2-.8L6 22.8h6.72s3.36.08 6.08-1.361c.4-.24.8-.48 1.12-.8Z',
      fill: '#fff',
    }),
  );
});
ocbcSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ocbc = {
  category: 'brand',
  colorable: false,
  name: 'ocbc',
  svg: ocbcSvg,
};
